import { render, staticRenderFns } from "./PaymentReceiptPrint.vue?vue&type=template&id=55bbca0a"
import script from "./PaymentReceiptPrint.vue?vue&type=script&lang=ts"
export * from "./PaymentReceiptPrint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports